import { render, staticRenderFns } from "./BreakDownbyStudentGroup.vue?vue&type=template&id=2dbcf6fd&scoped=true&"
import script from "./BreakDownbyStudentGroup.vue?vue&type=script&lang=ts&"
export * from "./BreakDownbyStudentGroup.vue?vue&type=script&lang=ts&"
import style0 from "./BreakDownbyStudentGroup.vue?vue&type=style&index=0&id=2dbcf6fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbcf6fd",
  null
  
)

export default component.exports